{
  "title": "Speak with Animals",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level divination (ritual)",
  "level": 1,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S",
  "duration": "10 minutes",
  "description": [
    "You gain the ability to comprehend and verbally communicate with beasts for the duration. The knowledge and awareness of many beasts is limited by their intelligence, but at minimum, beasts can give you information about nearby locations and monsters, including whatever they can perceive or have perceived within the past day. You might be able to persuade a beast to perform a small favor for you, at the DM’s discretion."
  ],
  "spellLists": ["bard", "druid", "ranger"]
}
